var rtl_rtlignore_default = {
  "rtl": "LYHyr",
  "ltr": "vyKKn"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
